
webpack.register(
    'modules/video-feed/video-feed',
    function() {
        return import('modules/video-feed/video-feed');
    },
    true
);